const projectRequestsPanel = {
  title: "Beiðnir þínar í þessu verkefni",
  newRequest: "Ný beiðni",
  empty: "Þú hefur ekki sent neinar beiðnir í þessu verkefni ennþá.",
  type: {
    data: "Gagnabeiðni",
    access: "Aðgangsbeiðni",
  },
  viewAll: "Skoða allar beiðnir þínar →",
};

export default projectRequestsPanel;
